/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSearchParams, useSearchParams } from "react-router-dom";

import { useAtom, useSetAtom } from "jotai";

import { PageQueryParamsInterface } from "@ts/interfaces/Checkout/PageQueryParamsInterface";

import {
    isProvidedQueryParamsAtom,
    pageQueryParamsAtom
} from "@atoms/checkoutAtom";

import { removeNullProperties } from "@utils/utils";

const useCheckoutQueryParams = () => {
    const [, setSearchParams] = useSearchParams() || [new URLSearchParams()];

    const [pageQueryParams, setPageQueryParams] = useAtom(pageQueryParamsAtom);
    const setIsProvidedQueryParams = useSetAtom(isProvidedQueryParamsAtom);

    const routeWithQueryParams = (pathname: string) => {
        return {
            pathname,
            search: pageQueryParams
                ? `?${createSearchParams(
                      removeNullProperties(pageQueryParams)
                  )}`
                : undefined
        };
    };

    const onSetupQueryParams = (
        newPageQueryParams: PageQueryParamsInterface
    ) => {
        // Query parameters are dynamically appending, not directly being passed.
        setIsProvidedQueryParams(false);

        setSearchParams(removeNullProperties(newPageQueryParams));
        setPageQueryParams(newPageQueryParams);
    };

    return {
        routeWithQueryParams,
        onSetupQueryParams
    };
};

export default useCheckoutQueryParams;
